import PageContent from "../components/PageContent";
import { getActiveBranchIds1 } from "../util/multipleBranch/getActiveBranchId";
import { isLoggedIn } from "../util/getToken";
import domain from "../domain";
import { useEffect , useState } from "react";
 
import SummaryComponent from "../components/SummaryComponent";

export default function AiSummary() {


    const [summaryData, setSummaryData] = useState(JSON.parse(localStorage.getItem("summaryData")));
  
    async function fetchData() {
 
  // we send all branches ids as body.
  const branches = getActiveBranchIds1();
//   console.log(branches);
  if (!isLoggedIn()) return;

  console.log("sending api request for summary data");
  try {
    const data1 = await fetch(`${domain}/api/summary`, {
      method: "Post",
      body: JSON.stringify({
        adminId: branches,// 
      }),
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
    });

    const data = await data1.json();
     console.log(data);
    return data.result;
  } catch (err) {
    console.error("Error fetching summary data:", err);
  }
}
useEffect(() => {
  // console.log("useEffect code")
    let summaryDataLatestDate = localStorage.getItem("summaryDataLatestDate");
    let currentDate = new Date().getTime();
// console.log("summaryDataLatestDate", new Date(Number(summaryDataLatestDate)));
    // Check if summary data is older than 6 days (6 * 24 * 60 * 60 * 1000 milliseconds)
     console.log(summaryDataLatestDate)
     console.log(new Date(Number(summaryDataLatestDate)))
  const timeDifferenceInDays = (currentDate - summaryDataLatestDate) / (24 * 60 * 60 * 1000);
     console.log("time difference", timeDifferenceInDays , "days")
    if (!summaryDataLatestDate || timeDifferenceInDays > 7) {
        go(); // If data is old or doesn't exist, fetch new data
        // Update the latest date in localStorage
       }
   
        
     
 async function go() {
  console.log("fetching new summary data from API");

      let data = await fetchData();
    let latestDate = data[0].summary[0]?.createdAt;
    console.log(latestDate)
    if(!latestDate){
      let PreviousMonday = new Date();
      PreviousMonday.setHours(3,0,0,0); // Set to midnight to avoid timezone issues
      let dayToSubtact = (PreviousMonday.getDay() + 6) % 7; // Calculate days to subtract to get to Monday
      PreviousMonday.setDate(PreviousMonday.getDate() - dayToSubtact);
     
      latestDate = PreviousMonday.getTime();
       
      console.log("No summary data available, setting latestDate to last Monday:", new Date(latestDate));
    }
    if(latestDate){
  localStorage.setItem("summaryDataLatestDate", new Date(latestDate).getTime());
      localStorage.setItem("summaryData", JSON.stringify(data));
      setSummaryData(data);
    }
  
    }
    
}, []);
// console.log("rendering AiSummary component with summaryData", summaryData);
  return (
    <PageContent>
        <h1>AI Summary</h1>
        <SummaryComponent Id={getActiveBranchIds1()} summaryData={summaryData} />
        </PageContent>
  );
}